import { render as lit, html, svg, TemplateResult, SVGTemplateResult } from "lit-html";
import { until } from "lit-html/directives/until.js";
import { styleMap } from "lit-html/directives/style-map";
import { classMap } from "lit-html/directives/class-map";
import { ifDefined } from "lit-html/directives/if-defined";
import { define, compose, element } from "./core/element";
import { property } from "./core/property";
import { shadow } from "./core/shadow";
import { slots, SlotsEvent } from "./core/slots";
import { render as defaultRender, requestUpdate } from "./core/render";
import { renderWithHooks } from "./hooks/core";
import { _callAllUseDisconnectedCallbacks } from "./hooks/use-disconnect";
import { _callAllUseEffectTeardownCallbacks } from "./hooks/use-effect";
var hooksDisconnect = function (host) {
    _callAllUseDisconnectedCallbacks(host);
    _callAllUseEffectTeardownCallbacks(host);
};
var ɵ0 = hooksDisconnect;
function templateWithHooks(template) {
    return function (host) { return renderWithHooks(host, function () { return template(host); }, function () { return requestUpdate(host); }); };
}
function litRenderer(template) {
    return function (host) {
        var result = template(host);
        return function (host, target) {
            lit(result, target);
        };
    };
}
function render(template) {
    var render = defaultRender(litRenderer(templateWithHooks(template)));
    var connect = render.connect;
    render.connect = function (host, key, invalidate) {
        var disconnect = connect &&
            connect(host, key, invalidate);
        return function () {
            disconnect && disconnect();
            hooksDisconnect(host);
        };
    };
    return render;
}
export { define, render, compose, element, property, slots, shadow, classMap, styleMap, ifDefined, html, svg, until, TemplateResult, SlotsEvent, SVGTemplateResult };
export { ɵ0 };
//# sourceMappingURL=component.js.map